import React, { useEffect, useState } from "react";

const itemLabel = (item) => {
  const extra = String(item?.otherText || "").trim();
  const label = String(item?.label || "").replace(/\.$/, "");
  return extra ? `${label} (${extra})` : label;
};

const RequestMissingDocumentsModal = ({
  open,
  items,
  selectedIds,
  sending,
  categoryLabel,
  onToggle,
  onSelectAll,
  onClearAll,
  onCancel,
  onSend,
}) => {
  const [otherSelected, setOtherSelected] = useState(false);
  const [otherMessage, setOtherMessage] = useState("");

  useEffect(() => {
    if (!open) return;
    setOtherSelected(false);
    setOtherMessage("");
  }, [open]);

  if (!open) return null;

  const trimmedOther = otherMessage.trim();
  const otherReady = otherSelected && Boolean(trimmedOther);
  const selectedCount = selectedIds.length + (otherReady ? 1 : 0);
  const totalCount = items.length + 1;
  const canSend = !sending && (selectedIds.length > 0 || otherReady);

  const toggleOther = () => {
    setOtherSelected((prev) => {
      const next = !prev;
      if (!next) setOtherMessage("");
      return next;
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div
        className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-labelledby="request-missing-docs-title"
      >
        <div className="px-5 py-4 border-b">
          <h3
            id="request-missing-docs-title"
            className="text-lg font-semibold text-blue-900"
          >
            Request missing documents
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Select the documents to include in the email
            {categoryLabel ? ` for ${categoryLabel}` : ""}.
          </p>
        </div>
        <div className="px-5 py-3 border-b flex items-center justify-between gap-2">
          <span className="text-sm text-gray-700">
            {selectedCount} of {totalCount} selected
          </span>
          <div className="flex items-center gap-3">
            <button
              type="button"
              className="text-sm font-medium text-blue-900 hover:underline"
              onClick={onSelectAll}
            >
              Select all
            </button>
            <button
              type="button"
              className="text-sm text-gray-600 hover:underline"
              onClick={() => {
                onClearAll();
                setOtherSelected(false);
                setOtherMessage("");
              }}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="px-5 py-3 overflow-y-auto flex-1 space-y-1">
          {items.map((item) => (
            <label
              key={item.id}
              className="flex items-start gap-2 p-2 rounded-md hover:bg-blue-50 cursor-pointer"
            >
              <input
                type="checkbox"
                className="mt-1 h-4 w-4"
                checked={selectedIds.includes(item.id)}
                onChange={() => onToggle(item.id)}
              />
              <span className="text-sm text-gray-800 leading-snug">
                {itemLabel(item)}
              </span>
            </label>
          ))}
          <label className="flex items-start gap-2 p-2 rounded-md hover:bg-blue-50 cursor-pointer">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4"
              checked={otherSelected}
              onChange={toggleOther}
            />
            <span className="text-sm text-gray-800 leading-snug font-medium">
              Other
            </span>
          </label>
          {otherSelected ? (
            <div className="pl-7 pr-2 pb-2">
              <textarea
                value={otherMessage}
                onChange={(event) => setOtherMessage(event.target.value)}
                rows={4}
                maxLength={2000}
                placeholder="Type a message to include in the email"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-900"
              />
              <p className="text-xs text-gray-500 mt-1">
                This note is sent to the agent with the document request.
              </p>
            </div>
          ) : null}
        </div>
        <div className="px-5 py-4 border-t flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={sending}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() =>
              onSend({ otherMessage: otherReady ? trimmedOther : "" })
            }
            disabled={!canSend}
            className="px-4 py-2 bg-blue-900 text-white rounded-md text-sm hover:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            {sending
              ? "Sending..."
              : `Send email (${selectedCount})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RequestMissingDocumentsModal;
